export default "__VITE_ASSET__CvRr$Xvq__"